import { render, staticRenderFns } from "./badMarkLabel.vue?vue&type=template&id=0f7eaf1c&scoped=true&"
import script from "./badMarkLabel.vue?vue&type=script&lang=js&"
export * from "./badMarkLabel.vue?vue&type=script&lang=js&"
import style0 from "./badMarkLabel.vue?vue&type=style&index=0&id=0f7eaf1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7eaf1c",
  null
  
)

export default component.exports